define('view/controller/booking/datetime/flexible-weekly/TimeFlexibleWeeklyDayView',['require','marionette','view/controller/booking/datetime/flexible-weekly/TimeFlexibleWeeklyDayItemView','lib/view/UnwrapBehavior','Config'],function (require) {

    var Marionette = require('marionette');
    var TimeFlexibleWeeklyDayItemView = require('view/controller/booking/datetime/flexible-weekly/TimeFlexibleWeeklyDayItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');
    var Config = require('Config');

    /**
     * Flexible weekly timeline day view (container)
     *
     * @class TimeFlexibleWeeklyDayView
     */
    return Marionette.CompositeView.extend({

        template: '#time_flexible_weekly_day_view',
        childView: TimeFlexibleWeeklyDayItemView,
        childViewContainer: '.sb_time_flexible_weekly_day_container',
        emptyDays : [],
        wlDaysShows: [],

        childViewOptions: function (model, index) {
            var data = {
                clientTimeZone: this.getOption('clientTimeZone'),
                isEmptyDay: this._isEmptyDay(),
                isDayOff: this.getOption('isDayOff'),
                isWlShows: this.wlDaysShows.indexOf(model.get('date')) >=0, //show slot once
            };
            this.wlDaysShows.push(model.get('date'));
            return data;
        },

        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        initialize: function () {
            this.collection = this.model.get('collection');
        },

        _isSlotFree: function (model, collectionDate) {
            //console.log(model.get('date'), collectionDate, Config.getInstance().isAllowedBookOverDay());
            if (model.get('date') !== collectionDate && !Config.getInstance().isAllowedBookOverDay()) {
                return false;
            }
            // allowed to book if the slot is free
            if (model.get('type') === 'free') {
                return true;
            }
            return false;
        },

        onBeforeRender: function () {
            this.wlDaysShows = [];
        },

        _isEmptyDay : function (){
            var _this = this;
            var isEmptyDay = true;
            //console.log(_this.collection);

            if(this.emptyDays.indexOf(_this.model.get('date')) >=0){
                return true;
            }

            this.collection.each(function (model) {
                if(isEmptyDay) {
                    var isSlotFree = _this._isSlotFree(model, _this.model.get('date'));
                    //console.log(model, isSlotFree);
                    if(isSlotFree){
                        isEmptyDay = false;
                    }
                }
            });

            if(isEmptyDay){
                this.emptyDays.push(_this.model.get('date'));
            }

            //console.log(isEmptyDay, _this.model.get('date'));

            return isEmptyDay;
        },

        serializeData: function () {
            var result = Marionette.ItemView.prototype.serializeData.apply(this);
            result.time_diff = this.getOption('clientTimeZone').get('time_diff');

            var date = Date.parseMysqlDate(result.date);

            result.day_name = date.getWeekDayName('medium');
            result.is_holiday = ([0, 6].indexOf(date.getDay()) !== -1);

            result.is_empty = this._isEmptyDay();
            result.is_day_off = this.getOption('isDayOff');
            //console.log(result, this.model);
            return result;
        },

        _isWaitingListDay : function (){
            var isWlEnabled = Config.getInstance().getPluginStatus('waiting_list');

            if(isWlEnabled && this._isEmptyDay() && !this.getOption('isDayOff')){
                return true;
            }
            return false;
        },

        onChildviewHoverTime: function (view, data) {
            if(data.model.get('type') !== 'free' && this._isWaitingListDay()){
                data.model.set('wl', true);
                this.triggerMethod('hover:time', data.model);
            }

            if (data.model.get('type') === 'free') {
                this.triggerMethod('hover:time', data.model);
            }
        },

        onChildviewSelectTime: function (view, data) {
            if(data.model.get('type') !== 'free' && this._isWaitingListDay()){
                data.model.set('wl', true);
                this.triggerMethod('select:time', data.model);
            }

            if (data.model.get('type') === 'free') {
                this.triggerMethod('select:time', data.model);
            }
        }

    });

});
